const TableName = Symbol.for("drizzle:Name");
export {
  TableName
};
